export default "__VITE_ASSET__CWRjoHWU__"